import { ErrorModel } from './error.model';

export class AppError {
    constructor(public errors: ErrorModel | string [] = [], public code?: number) {

    }
}
